/* eslint-disable react-hooks/rules-of-hooks */
import usePermissionsEndpoint from '../hooks/usePermissionsEndpoint';
import useReleasesEndpoint from '../hooks/useReleasesEndpoint';

export const hooks = {};
export const loadSharedHooks = () => {
  hooks.permissionsEndpoint = usePermissionsEndpoint();
  hooks.releasesEndpoint = useReleasesEndpoint();
};
